import API from "@/api";
// import translation from '../../../translation.json'
import { getField, updateField } from "vuex-map-fields";

const initialState = () => ({
  loadingBar: false,
  defaultPerfisPermissions: [],
  defaultSegmentationPermissions: [],
  perfisGroups: [],
  segmentationGroups: [],
  selectedGroup: {},
  // selectedPaineis: [],
  dashboardList: [],
  loadingPermissoes: false,
  groupNameRegExp: /^[A-Z_]{3,}$/,
  isLoadingPanelList: false,
  groupType: "perfis",
});

export const state = initialState();

export const getters = {
  getField,
};

export const actions = {
  async get({ state, dispatch, commit }) {
    commit("updateField", { path: "loadingBar", value: true });

    await dispatch("getPermissoes", state.groupType);

    const response = await API.axios.get(`/sso/api/v1/${state.groupType}`);
    if (response.status === 200) {
      commit("updateField", {
        path:
          state.groupType === "perfis" ? "perfisGroups" : "segmentationGroups",
        value: response.data,
      });
    }

    commit("updateField", { path: "loadingBar", value: false });
  },

  async createGroup({ state, commit }, newGroup) {
    commit("updateField", { path: "loadingBar", value: true });

    const response = await API.axios.post(
      `/sso/api/v1/${state.groupType}`,
      newGroup
    );

    commit("updateField", { path: "loadingBar", value: false });

    return response;
  },

  async updateGroup({ state, commit }, group) {
    commit("updateField", { path: "loadingBar", value: true });

    const response = await API.axios.put(
      `/sso/api/v1/${state.groupType}`,
      group
    );

    commit("updateField", { path: "loadingBar", value: false });

    return response;
  },

  async deleteGroup({ commit }, id) {
    commit("updateField", { path: "loadingBar", value: true });

    const response = await API.axios.delete(`/sso/api/v1/perfis/${id}`);

    commit("updateField", { path: "loadingBar", value: false });

    return response;
  },

  async getPaineis({ commit, state }) {
    commit("updateField", { path: "isLoadingPanelList", value: true });

    const response = await API.axios.get("/bff/api/v1/paineis");

    commit("updateField", { path: "isLoadingPanelList", value: false });
    if (response.status === 200) {
      commit("updateField", { path: "dashboardList", value: response.data });
    } else {
      commit("updateField", { path: "dashboardList", value: [] });
    }
  },

  async getPermissoes({ state, commit }) {
    commit("updateField", { path: "loadingPermissoes", value: true });

    const config = {
      params: new URLSearchParams({ type: state.groupType }),
    };

    if (state.groupType === "perfis") {
      const response = await API.axios.get("/sso/api/v1/permissoes", config);

      if (response.status === 200) {
        commit("updateField", {
          path: "defaultPerfisPermissions",
          value: response.data,
        });
      }
    } else if (state.groupType === "segmentacoes") {
      const response = await API.axios.get("/security/segmentacoes", config);

      if (response.status === 200) {
        commit("updateField", {
          path: "defaultSegmentationPermissions",
          value: response.data,
        });
      }
    }
    commit("updateField", { path: "loadingPermissoes", value: false });
  },

  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
